import { FormattedMessage, useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import Image from 'components/Common/Image'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import TextButton from 'LuxKit/Button/TextButton'
import LineExternalLinkAltIcon from 'LuxKit/Icons/line/LineExternalLinkAltIcon'

const EMPTY_STATE_IMAGE_ID = 'cvbrvk7aefcowhr5spzd'

interface Props {
  placeName: string
  searchUrl: string
}

function HotelListingEmptyState({ placeName, searchUrl }: Props) {
  const intl = useIntl()

  return (
    <Group direction="vertical" gap={16} horizontalAlign="center">
      <Image
        id={EMPTY_STATE_IMAGE_ID}
        width={399}
        height={168}
        alt={intl.formatMessage({
          id: 'n15jOY_j88Q7tNPrJvO-',
          defaultMessage: 'No hotels available',
          description: 'Alt text for empty state image when no hotels are found',
        })}
        format="gif"
      />
      <Group direction="vertical" gap={8} horizontalAlign="center">
        <Heading variant="heading5">
          {intl.formatMessage({
            id: 'cCgTm8voUp3ICLIWATWj',
            defaultMessage: 'No hotels available in this area',
            description: 'Heading when no hotel listings found in the selected area',
          })}
        </Heading>
        <BodyText variant="medium" colour="neutral-two">
          <FormattedMessage
            id="0cYlzwLE8_gtvXM8bvWY"
            defaultMessage="We don’t have any Luxury Escapes deals in {placeName} right now."
            description="Message when no Luxury Escapes hotel deals exist for a specific location"
            values={{ placeName }}
          />
        </BodyText>
      </Group>
      <TextButton
        kind="primary"
        shape="round"
        endIcon={<LineExternalLinkAltIcon />}
        href={searchUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {intl.formatMessage({
          id: 'ICWQS5psHyD8XpzfRzmP',
          defaultMessage: 'View more on Luxury Escapes',
          description: 'Button label to view more hotel deals on Luxury Escapes website',
        })}
      </TextButton>
    </Group>
  )
}

export default HotelListingEmptyState
